import React from 'react';

export const List = ({ label, name, activity }) => (
  <React.Fragment>
    <p><strong>{label}</strong></p>
    {Array.isArray(activity[name])
      ? activity[name].map(value => (
        <ul key={value}>
          <li>{value}</li>
        </ul>
      ))
      : <p>{activity[name]}</p>
    }
  </React.Fragment>
);

export default List;



// WEBPACK FOOTER //
// ./src/components/Summary/Controls/ControlList.js